<script lang="ts">
	import type { PointsInfoBannerContent } from '../../domain/points-info-banner/PointsInfoBannerContent.ts';
	import type { PointsInfoBannerType } from '../../domain/points-info-banner/PointsInfoBannerType.ts';
	import { onMount } from 'svelte';
	import TrackingService, { ActionName } from '../../services/tracking/TrackingService.ts';
	import { Topic } from '../../services/tracking/Topic.ts';
	import { onViewport } from '../../services/tracking/IntersectionObserver';

	let trackingService: TrackingService;

	let { content, type }: { content: PointsInfoBannerContent, type: PointsInfoBannerType }
		= $props();

	const trackClick = () => {
		trackingService.sendEvent(Topic.SubmitEvent, {
			up_PointsBanner: [ActionName.OPEN],
			up_BannerType: [type]
		}
		);
	};

	const trackSeen = () => {
		trackingService.sendEvent(Topic.SubmitEvent, {
			up_PointsBanner: [ActionName.SEEN],
			up_BannerType: [type]
		}
		);
	};

	const trackView = () => {
		trackingService.sendEvent(Topic.MergeEvent, {
			up_PointsBanner: [ActionName.VIEW],
			up_BannerType: [type]
		}
		);
	};

	const sheetProps = (): string => {
		const props = {
			id: 'points-info-banner-sheet',
			headline: content.sheetTitle,
			url: content.sheetUrl,
			noContentPadding: true,
			hideHeader: content.hideHeader,
			adaptiveAlignment: content.adaptiveAlignment
		};
		return JSON.stringify(props);
	};

	const click = async () => {
		trackClick();
	};

	onMount(() => {
		trackingService = new TrackingService();
		trackView();
	});

</script>
<div class="points-info-banner"
	id="points-info-banner"
	data-testid="points-info-banner"
	data-sheet-full-bleed-content="true"
	style="cursor: pointer; display:flex;"
	data-points-info-banner-type={type}
	use:onViewport
	onenterViewport={trackSeen}
>
	<oc-icon-v1 data-testid="icon_otto-up-points" class="oc-mr-75" oc-aria-label="otto-up-punkte"
		type="otto-up-points"></oc-icon-v1>

	<oc-link-v2
		variant="secondary"
		as-button=""
		data-testid="points-info-banner-description"
		data-oc-sheet-v1-create={sheetProps()}
		onclick={click}
	>
		{@html content.description}
	</oc-link-v2>
</div>
